import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';
import parseCssVariables from './lib/parse_css_variables.js';

/**
 * A component which displays colors from css variables.
 *
 * It will display:
 * - Variable name eg. `gray-000`
 * - Computed color eg. `#ff0000;`
 * - Original value eg: `--primary: var(--primary-500)`
 */
export default class SbColor extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static parsedCssVariables = {};

  static properties = {
    theme: { state: true },
    var: { type: String },
  };

  constructor() {
    super();

    this.loadThemeFromMainElement();

    /** @internal */
    this.theme ||= 'light';
  }

  connectedCallback() {
    super.connectedCallback();
    this.watchAttributeChange();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // this.constructor.observer.disconnect();
  }

  get displayValue() {
    return this.value.replace(/var\(--(.*?)\)/, '$1');
  }

  loadThemeFromMainElement() {
    this.theme = document.body.dataset.theme;
  }

  watchAttributeChange() {
    this.constructor.observer ||= new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'data-theme') {
          this.loadThemeFromMainElement();
        }
      });
    });

    this.constructor.observer.observe(document.body, { attributes: true });
  }

  /** @internal */
  get cssVar() {
    return `--${this.var}`;
  }

  /** @internal */
  get computedValue() {
    return getComputedStyle(document.body).getPropertyValue(this.cssVar);
  }

  /** @internal */
  get value() {
    return this.cssVariables[this.cssVar];
  }

  /** @internal */
  get cssVariables() {
    const selector = this.theme === 'light' ? ':root' : '[data-theme="dark"]';
    return (this.constructor.parsedCssVariables[this.theme] ||=
      parseCssVariables(selector));
  }

  /** @internal */
  get isPointer() {
    return this.value?.startsWith('var');
  }

  renderValue() {
    return html`<div><span title="Points to">${this.displayValue}</span></div>`;
  }

  render() {
    return html`
      <div class="fill" style="background-color:var(${this.cssVar})"></div>
      <main>
        <div class="name">${this.var}</strong></div>
        <div>${this.computedValue}</div>
        ${this.isPointer ? this.renderValue() : ''}
      </main>
    `;
  }
}

customElements.get('sb-color') || customElements.define('sb-color', SbColor);
